import React, { useContext } from 'react';
import { SIDEBAR_VIEWS } from '@vitl-services/constants/blog';

import Footer from './footer/footer';
import { FOOTER_DATA } from './footer/data';
import TopNavigationComponent from './top-nav/top-navigation';
import Sidebar from '../ui/sidebar/sidebar';
import { GlobalContext } from '@store/global-state';
import MobileSidebarMenu from '../mobile-sidebar-menu/mobile-sidebar-menu';

import 'vitl-component-library/dist/index.css';
//Global styles
import '../../styles/normalize.scss';
import '../../styles/global.scss';

interface IProps {
  children: React.ReactNode;
}

const Layout: React.FC<IProps> = ({ children }) => {
  const { sidebar } = useContext(GlobalContext);
  return (
    <>
      <TopNavigationComponent />
      <Sidebar>
        {SIDEBAR_VIEWS.navigation === sidebar && <MobileSidebarMenu />}
      </Sidebar>
      {children}
      <Footer content={FOOTER_DATA} />
    </>
  );
};

export default Layout;
